import { Foundation } from "foundation-sites";
import jquery from "jquery";

window.jQuery = jquery;
window.$ = jquery;

Foundation.addToJquery($);

jQuery(document).ready(($) => $(document).foundation());
